<template>
    <div id="Critical-Shortages" class="wrapper m0-50 critical">
        <div class="section">
            <div class="div-block-15">
                <div class="form-container">
                    <div class="form-block w-form">
                        <form v-if="!success&&!fail" id="wf-form-Request-Input-Materials---Hand-Sanitizer" name="wf-form-Request-Input-Materials---Hand-Sanitizer" data-name="Request Input Materials - Hand Sanitizer" class="form-wrapper"
                              @submit.prevent="submit">
                            <div class="form-title-container">
                                <div class="form-title">Request Input Materials - {{$route.params.productName}}<a href="https://prospero-uikit.webflow.io/2-content#"><strong><br></strong></a></div>
                                <p>Please review the <a href="https://buyandsell.gc.ca/specifications-for-COVID-19-products#600" target="_blank" class="link-blue">Government of Canada&#x27;s Product Specifications</a> prior to completing the form below.</p>
                            </div>
                            <div class="input-container"><label class="input-group-label">Facility Information</label>
                                <div class="input-container">
                                    <label for="Facility-Street-Address" class="input-label">Facility Street Address</label>
                                    <input v-model="form.facilityStreetAddress"
                                           @blur="$v.form.facilityStreetAddress.$touch()"
                                           type="text" class="text-input w-input" autofocus="true" maxlength="256" name="Facility-Street-Address" data-name="Facility Street Address" placeholder="Street Address" id="Facility-Street-Address" required="">
                                    <div class="text-red" v-if="$v.form.facilityStreetAddress.$error">
                                        <div v-if="!$v.form.facilityStreetAddress.required">A street address is required</div>
                                    </div>
                                </div>
                                <div class="input-container">
                                    <div class="w-row">
                                        <div class="upper-input-container w-col w-col-6">
                                            <label for="Facility-City" class="input-label">City</label>
                                            <input v-model="form.facilityCity" type="text" class="text-input w-input" maxlength="256" name="Facility-City" data-name="Facility City" placeholder="City" id="Facility-City" required="">
                                        </div>
                                        <div class="lower-input-container w-col w-col-6">
                                            <label for="Facility-Postal-Code" class="input-label">Postal Code</label>
                                            <input v-mask="'S#S#S#'"
                                                   v-model="form.facilityPostalCode"
                                                   @blur="$v.form.facilityPostalCode.$touch()"
                                                   type="text" class="text-input w-input" maxlength="256" name="Facility-Postal-Code" data-name="Facility Postal Code" placeholder="A1A 1A1" id="Facility-Postal-Code" required="">
                                        </div>
                                        <div class="text-red" v-if="$v.form.facilityPostalCode.$error">
                                            <div v-if="!$v.form.facilityCity.required">A city is required</div>
                                            <div v-if="!$v.form.facilityPostalCode.required">A postal code is required</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="input-container">
                                    <label for="Facility-Province" class="input-label">Province</label>
                                    <select v-model="form.facilityProvince" id="Facility-Province" name="Facility-Province" data-name="Facility Province" class="w-select">
                                        <option value="">Select one...</option>
                                        <option value="AB">Alberta</option>
                                        <option value="BC">British Columbia</option>
                                        <option value="MB">Manitoba</option>
                                        <option value="NB">New Brunswick</option>
                                        <option value="NL">Newfoundland and Labrador</option>
                                        <option value="NS">Nova Scotia</option>
                                        <option value="NT">Northwest Territories</option>
                                        <option value="NU">Nunavut</option>
                                        <option value="ON">Ontario</option>
                                        <option value="PE">Prince Edward Island</option>
                                        <option value="QC">Quebec</option>
                                        <option value="SK">Saskatchewan</option>
                                        <option value="YT">Yukon</option>
                                    </select>
                                    <div class="text-red" v-if="$v.form.facilityProvince.$error">
                                        <div v-if="!$v.form.facilityProvince.required">A province is required</div>
                                    </div>
                                </div>
                            </div>
                            <div class="input-container">
                                <label class="input-group-label">Request Details</label>
                                <div class="input-container">
                                    <label for="Material" class="input-label">Type of production capacity, ingredients, components or services you require:</label>
                                    <select v-model="form.material" id="Material" name="Material" data-name="Material" class="w-select">
                                        <option value="">Select one...</option>
                                        <option v-for="material in actualMaterials" v-bind:key="material.id" :value="material">{{material.description}}</option>
                                    </select>
                                </div>
                                <div v-if="form.material.id == this.ingredientOptionID">
                                    <div class="input-container">
                                        <div id="ingredients-container" class="ingredients-container">
                                            <label for="ingredient" class="input-label">Type of ingredients you require:</label>
                                            <select v-model="form.ingredient" id="ingredient" name="ingredient" data-name="ingredient" class="w-select">
                                                <option value="">Select one...</option>
                                                <option v-for="ingredient in this.ingredients" v-bind:key="ingredient.id" :value="ingredient">{{ingredient.description}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="(form.material.id == this.ingredientOptionID && form.ingredient) || (form.material.id != this.ingredientOptionID && form.material.id)" class="input-container">
                                <div id="materialDetails" class="group-input-container">
                                    <label v-if="form.material.id == this.ingredientOptionID" class="input-group-label">
                                        <strong v-if="this.form.ingredient.description">{{this.form.ingredient.description}}</strong>
                                        <strong v-else>Ingredient</strong>
                                    </label>
                                    <label v-else class="input-group-label"><strong>{{this.form.material.description}}</strong></label>
                                    <div class="input-container">
                                        <label v-if="form.material.id == this.ingredientOptionID" class="input-label">Description of the required ingredient:</label>
                                        <label v-else class="input-label">Description of the product/service:</label>
                                        <input v-model="form.description"
                                               @blur="$v.form.description.$touch()"
                                               type="text" class="text-input w-input" maxlength="256" placeholder="Your answer" id="description">
                                        <div class="text-red" v-if="$v.form.description.$error">
                                            <div v-if="!$v.form.description.required">A description is required</div>
                                        </div>
                                    </div>
                                    <div class="input-container">
                                        <label class="input-label">How many {{this.form.material.unitOfMeasure}} do you currently require?</label>
                                        <input v-model="form.qtyRequiredNow"
                                               @blur="$v.form.qtyRequiredNow.$touch()"
                                               v-mask="'########'" type="text" class="text-input w-input" maxlength="256" placeholder="Your answer" id="Required-Units">
                                        <div class="text-red" v-if="$v.form.qtyRequiredNow.$error">
                                            <div v-if="!$v.form.qtyRequiredNow.required">A value of one or more is required</div>
                                            <div v-if="!$v.form.qtyRequiredNow.minValue">A value of one or more is required</div>
                                        </div>
                                    </div>
                                    <div class="input-container">
                                        <label class="input-label">How many {{this.form.material.unitOfMeasure}} will you require per week?</label>
                                        <input v-model="form.qtyRequiredIn5Days"
                                               @blur="$v.form.qtyRequiredIn5Days.$touch()"
                                               v-mask="'########'" type="text" class="text-input w-input" maxlength="256" placeholder="Your answer" id="Required-Production-Rate">
                                        <div class="text-red" v-if="$v.form.qtyRequiredIn5Days.$error">
                                            <div v-if="!$v.form.qtyRequiredIn5Days.required">A value of one or more is required</div>
                                            <div v-if="!$v.form.qtyRequiredIn5Days.minValue">A value of one or more is required</div>
                                        </div>
                                    </div>
                                    <div class="input-container">
                                        <label class="input-label">What is your budget&#x27;s maximum cost per unit?</label>
                                        <input v-currency v-model="form.maximumCostPerUnit"
                                               @blur="$v.form.maximumCostPerUnit.$touch()"
                                               type="text" class="text-input w-input" maxlength="256" placeholder="Your answer" id="Maximum-Budget-Cost">
                                        <div class="text-red" v-if="$v.form.maximumCostPerUnit.$error">
                                            <div v-if="!$v.form.maximumCostPerUnit.required">A price per unit is required</div>
                                        </div>
                                    </div>
                                    <div v-if="form.material.id == this.ingredientOptionID" class="input-container">
                                        <label class="input-label">How can you receive this ingredient?</label>
                                        <label class="w-checkbox checkbox-field">
                                            <input v-model="form.transportArray" type="checkbox" id="Tanker Truck (14,000 kg)" class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-select" value="Tanker Truck (14,000 kg)">
                                            <span class="checkbox-label w-form-label">Tanker Truck (14,000 kg)</span>
                                        </label>
                                        <label class="w-checkbox checkbox-field">
                                            <input v-model="form.transportArray" type="checkbox" id="Totes (1,000 kg)" class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-select" value="Totes (1,000 kg)">
                                            <span class="checkbox-label w-form-label">Totes (1,000 kg)</span>
                                        </label>
                                        <label class="w-checkbox checkbox-field">
                                            <input v-model="form.transportArray" type="checkbox" id="Drums (200 kg)" class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-select" value="Drums (200kg)">
                                            <span class="checkbox-label w-form-label">Drums (200 kg)</span>
                                        </label>
                                        <label class="w-checkbox checkbox-field other">
                                            <div>
                                                <input v-model="form.transportArray" type="checkbox" id="Other Delivery Method" class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-select" value="other">
                                                <input v-model="form.otherDeliveryMethod" type="text" placeholder="Other..." class="text-input w-input" maxlength="256" id="Other-Delivery-Method-Description" style="padding-left: 10px">
                                            </div>
                                        </label>
                                        <div class="text-red" v-if="$v.form.transportArray.$error">
                                            <div v-if="(!$v.form.transportArray.sometimesRequired)">A method of delivery is required</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <input v-on:click="submit" type="button" value="Submit" data-wait="Please wait..." class="submit-button w-button">
                        </form>
                            <div v-if="validation||success||fail" class="form-block w-form">
                                <div class="form-success" v-if="success">
                                    <div>Thank you! Your submission has been received.<br><br>You will receive a confirmation email
                                        with information on managing your post.
                                    </div>
                                </div>
                                <div class="form-fail" v-if="fail">
                                    <div>Oops! Something went wrong while submitting the form.</div>
                                </div>
                                <div class="input-container form-fail" v-if="validation">
                                    <div>Please verify that everything you've entered is correct.</div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {formService} from "../../assets/js/services/formService";
    import {minValue, required} from "vuelidate/lib/validators";

    export default {
        name: "RequestMaterials",
        data(){
            return {
                productArray: [],
                product: [],
                materials: [],
                actualMaterials: [],
                ingredients: [],
                ingredientOptionID: "",
                ingredientDeliveryMethods: "",
                otherIndex: "",
                form: {
                    material: "",
                    ingredient: "",
                    facilityProvince: "",
                    facilityPostalCode: "",
                    facilityCity: "",
                    facilityStreetAddress: "",
                    description: "",
                    qtyRequiredNow: "",
                    qtyRequiredIn5Days: "",
                    maximumCostPerUnit: "",
                    transportArray: [],
                    otherDeliveryMethod: "",
                },
                demands: [{
                    requestId: "",
                    productRequest: {
                        id: ""
                    },
                    materialRequest: {
                        id: "",
                        materialName: "",
                        otherMaterial: false
                    },
                    description: "",
                    qtyRequiredNow: 0,
                    qtyRequiredIn5Days: 0,
                    qtyRequiredPerMonth: 0,
                    requiredAtStreetAddress: "",
                    requiredInCity: "",
                    requiredInState: "",
                    requiredInCountry: "",
                    requiredAtPostalCode: "",
                    msdsLink: "",
                    maximumCostPerUnit: 0,
                    comments: "",
                    ingredientDeliveryMethod: "",
                    ingredientStorage: null,
                    questionStorageAreaRegulatory: ""
                }],
                success: false,
                fail: false,
                validation: false,
            }
        },
        created () {
            this.productArray = JSON.parse(localStorage.getItem('ProductsMaterialsList'));
            this.product = this.productArray.filter(p => p.productType == this.$route.params.productType);
            this.materials = this.product[0].materialList;
            this.actualMaterials = this.product[0].materialList.filter(m => m.ingredient == false);
            this.ingredients = this.product[0].materialList.filter(m => m.ingredient == true);
            this.ingredientOptionID = this.materials.filter(m => m.materialName == "Ingredients")[0].id;//Get the id of "Ingredients"
        },
        validations: {
            form: {
                facilityStreetAddress: { required },
                facilityCity: { required },
                facilityProvince: { required },
                facilityPostalCode: { required },
                description: { required },
                qtyRequiredNow: { required,  minValue: minValue(1)},
                qtyRequiredIn5Days: { required, minValue: minValue(1) },
                maximumCostPerUnit: { required },
                transportArray: { sometimesRequired(transportArray) {
                    if (this.form.ingredient.description){//They've selected an ingredient
                        if (transportArray.length == 0){//Make sure they entered a value
                            return false;
                        }
                        else if (transportArray.indexOf("other") >= 0){//If they chose other, make sure they entered something in the text box
                            if (!this.form.otherDeliveryMethod){
                                return false;
                            }
                        }
                        else {
                            return true;
                        }
                    }
                    else {
                        return true;
                    }
                    return true;
                }
                }

            },
        },
        components: {
        },
        methods: {
            submit () {
                this.validation = false;
                this.success = false;
                this.fail = false;

                this.$v.form.$touch();
                if(this.$v.form.$error){
                    this.validation = true;
                    return;
                }

                this.demands[0].requiredAtStreetAddress = this.form.facilityStreetAddress;
                this.demands[0].requiredInCity = this.form.facilityCity;
                this.demands[0].requiredInState = this.form.facilityProvince;
                this.demands[0].requiredAtPostalCode = this.form.facilityPostalCode;
                this.demands[0].productRequest.id = this.product[0].id;

                if(this.form.material.id == this.ingredientOptionID){//The user is selecting an ingredient
                    this.demands[0].materialRequest.id = this.form.ingredient.id;
                    this.demands[0].materialRequest.materialName = this.form.ingredient.materialName;
                    if (this.form.ingredient.materialName == "Other"){//The user has selected a non-standard ingredient
                        this.demands[0].materialRequest.otherMaterial = true;
                    }
                    else {
                        this.demands[0].materialRequest.otherMaterial = false;
                    }
                }
                else {//The user is selecting a material
                    this.demands[0].materialRequest.id = this.form.material.id;
                    this.demands[0].materialRequest.materialName = this.form.material.materialName;
                    if (this.form.material.materialName == "Other"){//The user has selected a non-standard material
                        this.demands[0].materialRequest.otherMaterial = true;
                    }
                    else {
                        this.demands[0].materialRequest.otherMaterial = false;
                    }
                }

                this.demands[0].description = this.form.description;
                this.demands[0].qtyRequiredNow = this.form.qtyRequiredNow;
                this.demands[0].qtyRequiredIn5Days = this.form.qtyRequiredIn5Days;
                this.demands[0].qtyRequiredPerMonth = 0;
                this.demands[0].maximumCostPerUnit = this.$parseCurrency(this.form.maximumCostPerUnit);

                this.otherIndex = this.form.transportArray.indexOf("other");//Check to see if the user selected other
                if (this.otherIndex >= 0) {//They did
                    this.ingredientDeliveryMethods = this.form.transportArray;
                    this.ingredientDeliveryMethods.splice(this.otherIndex, 1, this.form.otherDeliveryMethod)//Splice in the value they entered in place of the 'other' placeholder
                } else {
                    this.ingredientDeliveryMethods = this.form.transportArray;
                }

                this.demands[0].ingredientDeliveryMethod = this.ingredientDeliveryMethods.toString();

                formService.requestMaterials(this.demands).then(() => {this.success = true;})
                    .catch((error) => {
                        if (error.status === 'UNPROCESSABLE_ENTITY'){
                            this.validation = true;
                        }
                        else {
                            this.fail = true;
                        }
                    });
            }
        }
    }
</script>

<style scoped>

</style>
